var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.353,
    height: 137.778,
    viewBox: "0 0 146.353 137.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop-ic",
    transform: "translate(-2522 3156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M2668.353-3063.678h-31.372c-.119-.729-.229-1.413-.368-2.268h29.237v-87.6H2524.473v87.491h29.242c-.112.863-.2,1.552-.308,2.376H2522V-3156h146.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M2702.632-2703.42c-2.855-.476-5.736-.832-8.558-1.453a39.73,39.73,0,0,1-14.559-6.33c-1.484-1.049-1.82-2.115-1.034-3.2.734-1.009,1.9-1.049,3.274-.111,8.7,5.929,18.446,7.583,28.719,6.938a41.965,41.965,0,0,0,17.363-4.7c1.381-.737,2.671-1.645,4-2.475a2.055,2.055,0,0,1,2.927.34,1.981,1.981,0,0,1-.665,2.955,41.08,41.08,0,0,1-16.158,6.873c-2.415.49-4.87.78-7.307,1.16Z",
    transform: "translate(-111.457 -314.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M2656.634-2919.086l3.354-1.984c-2.314,14.446,8.892,24.666,20.395,24.5,11.274-.167,22.081-10.216,19.807-24.532l3.4,2.039c.849-2.112,1.727-4.15,2.463-6.238.16-.455-.137-1.105-.308-1.639-2.843-8.875-5.727-17.736-8.541-26.62a6.373,6.373,0,0,1,5.284-8.448,6.279,6.279,0,0,1,6.733,4.2c3.342,10.212,6.644,20.438,9.824,30.7a6.829,6.829,0,0,1-.152,4.168c-2.871,7.453-5.823,14.879-8.954,22.226-2,4.7-5.921,7.623-10.352,9.834-8.279,4.131-17.076,5.063-26.146,3.877a36.836,36.836,0,0,1-16.333-5.951,19.852,19.852,0,0,1-7.624-9.53c-2.486-6.531-5.177-12.985-7.853-19.442a8.537,8.537,0,0,1-.229-6.235c3.212-9.8,6.326-19.641,9.521-29.452a6.269,6.269,0,0,1,6.159-4.431,6.04,6.04,0,0,1,5.913,4.513,9.4,9.4,0,0,1-.216,4.592c-2.664,8.631-5.457,17.224-8.279,25.8a4.135,4.135,0,0,0,.152,3.265C2655.365-2922.331,2655.958-2920.737,2656.634-2919.086Z",
    transform: "translate(-84.93 -138.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M2715.026-2849.294a17.976,17.976,0,0,1,18.03-17.932,17.973,17.973,0,0,1,17.965,18,18.074,18.074,0,0,1-18.034,17.978A18.068,18.068,0,0,1,2715.026-2849.294Z",
    transform: "translate(-137.85 -206.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M2696.151-2838.842c.093-2.251.2-2.362,2.181-2.36q1.633,0,3.266.029c.073,0,.144.1.214.147-.787,2.184-.787,2.184-3.017,2.184Z",
    transform: "translate(-124.371 -224.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M2845.478-2838.838a21.748,21.748,0,0,1-4.467-.082c-.716-.167-1.24-1.156-1.85-1.775l.2-.459a36.144,36.144,0,0,1,4.951.092C2844.729-2841,2844.99-2839.816,2845.478-2838.838Z",
    transform: "translate(-226.502 -224.82)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIc);
export default __webpack_public_path__ + "static/media/desktop-ic.98d056fa44d8a91e14501c8b0230fecf.svg";
export { ForwardRef as ReactComponent };